"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectedCountryIdSelector = exports.countriesOptionsSelector = void 0;
const countriesOptionsSelector = (state) => {
    return state.countries.countries.map((country) => {
        return {
            label: country.name,
            value: country.id,
        };
    });
};
exports.countriesOptionsSelector = countriesOptionsSelector;
const selectedCountryIdSelector = (state) => {
    return state.countries.selectedCountryId;
};
exports.selectedCountryIdSelector = selectedCountryIdSelector;
